import { render, staticRenderFns } from "./NewUserModel.vue?vue&type=template&id=ad598d16&"
import script from "./NewUserModel.vue?vue&type=script&lang=ts&"
export * from "./NewUserModel.vue?vue&type=script&lang=ts&"
import style0 from "./NewUserModel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports